<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h1 class="card-title ml-3 d-none d-sm-none d-xs-none d-md-none d-lg-block d-xl-block d-xxl-block"><strong>{{ title }} <button type="button" class="btn btn-info btn-fill float-right" @click="goBack"
                style="border-radius: 25px !important;background: #651366 !important;">
                <strong>Volver</strong>
              </button></strong> </h1>
            <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
              <template slot="header">
                
                <!-- <p class="card-category ml-3">{{ description }}</p> -->
              </template>
  
              <div class="row">
                <div class="col-md-4 d-none d-sm-none d-xs-none d-md-none d-lg-block d-xl-block d-xxl-block">
                <div class="input-group p-2 ml-md-4">
                  <input type="text" v-model="finder" v-on:keyup="loadElements" v-on:keyup.enter="loadElements"
                    class="form-control" :placeholder="finderLabel" aria-label="Recipient's username"
                    aria-describedby="basic-addon2" style="border-radius: 25px !important;">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-secondary" type="button" @click="loadElements" style="border-radius: 50px !important; right: 95%;"><v-icon
                        name="search"></v-icon></button>
                  </div>
                </div>
              </div>
              <div class="col-md-1 pt-md-2 d-none d-sm-none d-xs-none d-md-none d-lg-block d-xl-block d-xxl-block">
                <button
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Limpiar filtros"
                  :class="'btn btn-sm m-1 btn-fill float-right  btn-info '"
                  @click.prevent="cleanFilters()"
                  style="border-radius: 10px !important; height: 40px; right: 50px !important; position: relative;"
                >
                  <span style="color: white">
                    <v-icon name="trash" class="mx-1" fill="white"></v-icon>
                  </span>
                </button>
              </div>
              <div class="col-md-4 d-block d-sm-block d-xs-block d-md-block d-lg-none d-xl-none d-xxl-none">
                <div class="input-group p-2" style="width: 340px;">
                  <input type="text" v-model="finder" v-on:keyup="loadElements" v-on:keyup.enter="loadElements"
                    class="form-control" :placeholder="finderLabel" aria-label="Recipient's username"
                    aria-describedby="basic-addon2" style="border-radius: 25px !important;">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-secondary" type="button" @click="loadElements" style="border-radius: 50px !important; right: 95%;"><v-icon
                        name="search"></v-icon></button>
                       
                  </div>
                  <button
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Limpiar filtros"
                  :class="'btn btn-sm m-1 btn-fill float-right  btn-info '"
                  @click.prevent="cleanFilters()"
                  style="border-radius: 10px !important; height: 40px; right: 35px !important; position: relative;"
                >
                  <span style="color: white">
                    <v-icon name="trash" class="mx-1" fill="white"></v-icon>
                  </span>
                </button>
                </div>
              </div>
  
                <div class="col-md-4 m-4 d-none d-sm-none d-xs-none d-md-none d-lg-block d-xl-block d-xxl-block">
                  <h5 class="float-right m-1 d-none d-sm-none d-xs-none d-md-none d-lg-block d-xl-block d-xxl-block" style="position: relative;">
                   Fecha de inspección : {{ formattedDate }}
      </h5>
      
      
  
                </div>
                <div class="col-md-7 d-block d-sm-block d-xs-block d-md-block d-lg-none d-xl-none d-xxl-none">
                  <h5 class="float-right " style="position: relative; font-size: 16px;">
                   Fecha de inspección : {{ formattedDate }}
      </h5>
      
      
  
                </div>
  
               
              </div>
              
              
              <div class=" h-100 mt-1" style="border-color: none !important; overflow-x: hidden !important; ">
                <h5 style="position: relative; left: 40px;">         Datos del vehículo:</h5>
                <br>
    <div class="col-12 mb-3 " v-for="(item, index) in UsersTmp" :key="index" :metaInfo="metaInfo">
      <div class="card-body justify-content-center d-flex" style="background-color: #F8F8F8;border-radius: 20px !important;box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.5);">
          <div class="row justify-content-center justify-content-sm-start col-12">
            <div class="col-2 col-sm-2 col-10 px-0" >
        <img v-if="item.url_image != null && item.url_image != undefined && item.url_image != '' && item.url_image != 'prueba'" class="img-fluid mx-auto d-block mt-2" :src="item.url_image" onerror="this.onerror=null;src=this.default_img"  style=" text-align: center;  border-radius: 20px; height: 120px;"/>
        <img v-else class="img-fluid mx-auto d-block mt-2" src="https://play-lh.googleusercontent.com/Fa-hPHOekHE_3QxlVqjlnz1SCnwEye8BAVsqcHX4tzFTdiY9hM6U1FO1hc1YyTYWh0o=s200"  style=" text-align: center;  border-radius: 20px; height: 120px;"/>
    </div>
              <div class="col-sm-3 col-10 text-center text-sm-start px-2 mt-3">
                  <h5 class="card-title " style="color: black !important;"><strong>Color: {{ item.color }}</strong></h5>
                  <h5 class="card-title " style="color: black !important;"><strong>Modelo: {{ item.name }}</strong></h5>
                  <h5 class="card-title" style="color: black !important;"><strong>Año: {{ item.year }}</strong></h5>
                  <h5 class="card-title" style="color: black !important;"><strong>Placa: {{ item.plate }}</strong></h5>
              </div>
              
                <div class="col-2 col-sm-2 col-10 mt-3 px-0">
                  <img v-if="item.user.url_image != null && item.user.url_image != undefined && item.user.url_image != '' && item.user.url_image != 'prueba'" class="img-fluid mx-auto d-block mt-2" :src="item.user.url_image"   style="height: 80px; width: 80px; text-align: center;  border-radius: 50px;"/>
        <img v-else  class="img-fluid mx-auto d-block mt-2" src="https://static.vecteezy.com/system/resources/thumbnails/008/442/086/small_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg" onerror="this.onerror=null;src=this.default_img"   style="height: 80px; width: 80px; text-align: center;  border-radius: 50px;"/>
                </div>
                <div class="col-sm-3 col-10 align-items-center row text-center text-sm-start" >
                  
                  <h4  style="color: black !important;"><strong>{{ item.user.first_name }} {{ item.user.last_name }}</strong></h4>
                  <p  style="color: black !important; font-size: 16px;" > {{ formatDate(item.user.birthdate) }}</p>
                </div>    
              
              
              <div class="col-sm-2 col-12 align-items-center d-flex justify-content-center" >
                  <button type="button" data-toggle="tooltip" data-placement="top" title="Crear nuevo"
                    :class="'btn btn-fill  btn-info'" @click.prevent="goView(item)" style="border-radius: 25px !important; background: #F0C505!important;">
                    <span style="color:white; font-size: 14px;"> 
                      <strong>Comenzar</strong></span>
                  </button>
  
                </div>
              
            
  
          </div>
      </div>
    </div>

   
  
  
  
    
  
         </div>
         <div class="row justify-content-center mx-auto col-12 ">
  <div class="col">
    <ul class="pagination justify-content-center">
      <li class="page-item" :class="{ 'disabled': metaInfo.current_page === 1 }" @click="changePage('minus')">
        <a class="page-link" aria-label="Previous" role="button">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li class="page-item"  :class="{ 'active': metaInfo.current_page === metaInfo.first_page }"
        @click="changePageByNumber(metaInfo.current_page)">
        <a style="background: orange !important; color: white;"class="page-link">{{ metaInfo.current_page }}</a>
      </li>
      <!-- <li class="page-item" v-if="metaInfo.current_page > metaInfo.first_page + 2">
        <a class="page-link">...</a>
      </li> -->
      <template v-for="pageNumber in displayedPages">
        <li class="page-item"  :class="{ 'active': pageNumber === metaInfo.current_page }"
          @click="changePageByNumber(pageNumber)">
          <a  class="page-link">{{ pageNumber }}</a>
        </li>
      </template>
      <!-- <li class="page-item" v-if="metaInfo.last_page - metaInfo.current_page > 1">
        <a class="page-link">...</a>
      </li> -->
      <!-- <li class="page-item"  :class="{ 'active': metaInfo.current_page === metaInfo.last_page }"
        @click="changePageByNumber(metaInfo.last_page)">
        <a  style="background: orange !important; color: white;" class="page-link">{{ metaInfo.last_page }}</a>
      </li> -->
      <li  class="page-item" :class="{ 'disabled': metaInfo.current_page === metaInfo.last_page }"
        @click="changePage('plus')">
        <a   class="page-link" aria-label="Next" role="button">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </div>
</div>
            </card>
  
          </div>
  
  
  
  
  
        </div>
      </div>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
    </div>
  </template>
  <script>
  function clearAccents(cadena) {
    let chars = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ú: "u",
      à: "a",
      è: "e",
      ì: "i",
      ò: "o",
      ù: "u",
      ñ: "n",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ú: "U",
      À: "A",
      È: "E",
      Ì: "I",
      Ò: "O",
      Ù: "U",
      Ñ: "N",
    };
    let expr = /[áàéèíìóòúùñ]/gi;
    let res = cadena.replace(expr, function (e) {
      return chars[e];
    });
    return res;
  }
  
  import { mapState } from "vuex";
  import { mapActions } from "vuex";
  import Swal from "sweetalert2";
  import "sweetalert2/src/sweetalert2.scss";
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Multiselect from "vue-multiselect";
  import moment from "moment";
  import Cookies from "js-cookie";
import { all } from "axios";
  
  export default {
    components: {
      LTable,
      Card,
      Multiselect,
    },
    data() {
      return {
        //LABELS 
        title: 'Nueva inspección',
        description: 'Podrás gestionar a los administradores de la plataforma',
        buttonNewLabel: 'Crear nueva inspección',
        buttonNewUrl: 'InspectionsNew',
        buttonEditUrl: 'InspectionsEdit',
        finderLabel: 'Placa del vehículo',
        dateTmp: "",
        dateSaveTmp: "",
        timeSaveTmp:"",
        id_user_logged: Cookies.get("id"),
        //VARIABLE
        finder: '',
        metaInfo: {},
        sortOrder: "asc",
        // sortKey: "first_name",
        default_img:'public/img/logochami.png',
        //FILTERS
        active_model: "",
        activeTmp: [
          {
            id: 1,
            name: "Activo",
          },
          {
            id: 0,
            name: "Inactivo",
          },
        ],
        
        //TABLE DATA
        tableData: {
          columns: [
          
            {
              name: 'Nombre',
              key: 'name'
            },
            {
              name: 'Apellido',
              key: 'last_name'
            },
            {
              name: 'Cédula',
              key: 'dni'
            },
            {
              name: 'Correo',
              key: 'email'
            },
            {
              name: 'Teléfono celular',
              key: 'phone_1'
            },
            {
              name: 'Fecha inscripción',
              key: 'created_at',
            },
  
            {
              name: 'Acciones',
              key: 'actions',
            }
          ],
          data: [],
  
        },
        //DATA Variables
        Users: [],
        UsersTmp: [],
  
        //TABLE Buttons
        buttons: [
          {
            icon: 'eye',
            icon_negative: 'eye',
            type_button: 'btn-info',
            tooltip: 'Ver Detalles',
            url: '/admin/users/admins/edit',
            type_action: 'go_url',
            action: 'go_url',
            fill_icon: "#f76e2a",
            background_color: "white",
          },
          {
            icon: 'check-square',
            icon_negative: 'minus-square',
            type_button: 'btn-warning',
            tooltip: 'Cambiar Estatus',
            url: '',
            type_action: 'go_method',
            action: 'changeStatus',
            fill_icon: "#651366",
            background_color: "white",
          },
          {
            icon: "trash",
            icon_negative: "trash",
            type_button: "btn-danger",
            tooltip: "Eliminar administrador",
            url: "",
            type_action: "go_method",
            action: "rejectedStatus",
            fill_icon: "#8CC540",
            background_color: "white",
          },
        ]
  
  
      }
    },
    computed: {
      ...mapState({
        me: (state) => state.auth.me,
        me_rol: (state) => state.auth.me_rol,
      }),
      sortOptions() {
        return [];
      },
      formattedDate() {
         
        const today = moment(); // Create a moment object representing the current date
        this.dateTmp = today.format('DD-MM-YYYY'); // Format the date and assign it to dateTmp
        return this.dateTmp;
       
      },
      formattedDateSave() {
         
         const today = moment(); // Create a moment object representing the current date
         this.dateSaveTmp = today.format('YYYY-MM-DD '); // Format the date and assign it to dateTmp
         this.timeSaveTmp = today.format('HH:mm:ss');
         return this.dateSaveTmp && this.timeSaveTmp;
        
       },
      // rows() {
      //   return this.UsersTmp.length;
      // },
      displayedPages() {
      const currentPage = this.metaInfo.current_page;
      const lastPage = this.metaInfo.last_page;
      const range = 2; // Número de páginas a mostrar a cada lado de la página actual

      const startPage = Math.max(currentPage - range, this.metaInfo.first_page + 1);
      const endPage = Math.min(currentPage + range, lastPage - 1);
      const pages = [];

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    }
    },
    mounted() {
      this.loadElements();
      this.formattedDateSave();
    },
    updated() {
      console.log(this.user);
    },
    methods: {
      ...mapActions([
        "getData",
        "changeStatusData",
        "updateData",
        "createData",

      ]),
      goBack() {
        window.history.go(-1);
      },
      goNew() {
        this.$router.push({ name: this.buttonNewUrl });
      },
      goView(item) {
        Swal.fire({
          title: "¿Está seguro de que desea comenzar la inspección?",
          // text: "Esta acción no se puede deshacer.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#ff7600', // Naranja
          cancelButtonColor: '#651366', // Morado
          reverseButtons: true,
          confirmButtonText: 'Sí, comenzar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
        console.log(
        item.id_user,"id_user",
        item.id," id_vehicle ",
        this.dateSaveTmp,"date",
        this.id_user_logged,"id_user_inspector ")
          if (result.isConfirmed) {
            let form = {
              url: "inspection/save",
              data: {
                id_user: item.id_user,
                id_vehicle: item.id,
                date: this.dateSaveTmp,
                inspection_time: this.timeSaveTmp,
                id_user_inspector: this.id_user_logged,

              },
            };

            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Se creo la inspección correctamente",
                    icon: "success",
                    showConfirmButton: false,
                    showLoaderOnConfirm: true,
                    timer: 1000,
                  });

                  this.$router.push({ path: '/admin/inspections/review/'+ response.data.id });
                }
                else if (response.code === 409) {
                    Swal.fire({
                      title: 'Inspección en progreso',
                      text: 'Esta inspección ya esta en progreso',
                      icon: 'warning',
                      customClass: {
                        confirmButton: 'btn-info my-custom-button', // Estilo de botón personalizado
                        confirmButtonColor: '#ffffff !important', // Color de fondo blanco del botón de confirmación
                        confirmButtonText: 'Aceptar'
                      },
                      buttonsStyling: false // Desactivar el estilo predeterminado de SweetAlert 2
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.$router.push({ path: '/admin/inspections/review/' + response.data.id  });
                      }
                    });
                  }
                // else if (response.code === 409) {
                //   Swal.fire({
                //     title: 'Documento repetido',
                //     text: 'El documento se encuentra repetido',
                //     icon: 'warning',
                //     customClass: {
                //       confirmButton: "btn-info"
                //     },
                //     confirmButtonText: 'Aceptar',
                //   })
                // }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                this.$toaster.warning("Ocurrio un error al registrar los datos, verifica la información registrada");

              });
           
          }
        });
      },
      cleanFilters() {
        this.finder = "";
        this.active_model = "";
        this.loadElements();
      },
  
      // formatDate(date) {
      //   return moment(date).format("DD/MM/YYYY");
      // },
      formatDate(date) {
    return moment(date).format("DD [de ]MMMM [de] YYYY"); // Ejemplo: 27 de Mayo de 2024
  },
  changePageByNumber(page) {
      this.metaInfo.current_page = page;
      this.loadElements();
    },
    changePage(type) {
      if (type == "plus") {
        if (this.metaInfo.current_page < this.metaInfo.last_page) {
          this.metaInfo.current_page += 1;
        }
        this.loadElements();
      } else {
        if (this.metaInfo.current_page > this.metaInfo.first_page) {
          this.metaInfo.current_page -= 1;
        }
        this.loadElements();
      }
    },
      loadElements() {
        let form = {
          url: 'vehicle/all',
          params: {
            active: this.active_model ? this.active_model.id : null,
            // order_key: this.sortKey,
            // order_value: this.sortOrder,
            page: 1,
            limit: 10,
          }
  
        };
  
       
  
        if (this.finder != '') {
          console.log('Searching:' + this.finder);
          form.params.query = this.finder;
        }
        if (this.metaInfo.current_page > 1) {
        form.params.page = this.metaInfo.current_page;
      }
        this.isBusy = true;
        this.getData(form)
          .then((response) => {
            response.data.data.forEach((element) => {
              element.created_at = this.formatDate(element.created_at);
              element.birthdate = this.formatDate(element.birthdate);
            });
            this.isBusy = false;
            if (response.code === 200) {
              this.Users = response.data.data;
              this.metaInfo = response.data.meta;
              this.UsersTmp = this.Users;
              console.log(this.UsersTmp,"Aqui estan los datos")
              console.log(this.UsersTmp.id,"id del edit")
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      changeStatus(data) {
        let active = data.active === 1 ? 0 : 1;
        let title = data.active === 1 ? "Desactivar" : "Activar";
        let title2 = data.active === 1 ? "Desactivado" : "Activado";
        let text =
          data.active === 1
            ? "¿Estás seguro de desactivarlo ahora?"
            : "¿Estás seguro de activarlo ahora?";
        Swal.fire({
          title: title,
          text: text,
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#651366",
          cancelButtonColor: "#F76E2A",
          confirmButtonText: "Cambiar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            let form = {
              id: data.id,
              url: 'user/change_status',
              status: active,
            };
            this.changeStatusData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.loadElements();
                  data.active = active;
                  Swal.fire({
                    title: title2,
                    icon: "success",
                    confirmButtonColor: '#651366',
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      },
      
      rejectedStatus(data) {
        let title = "Eliminar administrador";
  
        let text = "¿Estás seguro de eliminar este administrador?";
        Swal.fire({
          title: title,
          text: text,
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#651366",
          cancelButtonColor: "#F76E2A",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            let form = {
              id: data.id,
              url: "user/change_status",
              status: 2,
            };
            this.changeStatusData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.loadElements();
                  // data.active = active;
                  Swal.fire({
                    title: "El administrador fue eliminado",
                    icon: "success",
                  });
                  // location.reload();
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      },
    },
  }
  </script>
  
  
  <style>
.my-custom-button {
  background-color: #F76E2A; /* Color de fondo blanco */
  border: 1px solid #F76E2A; /* Borde azul */
  color: #ffffff !important; /* Texto azul */
  padding: 10px 20px; /* Relleno */
  border-radius: 5px; /* Bordes redondeados */
  transition: color 0.3s ease; /* Animación de color suave */
}

.my-custom-button:hover {
  color: #ffffff !important; /* Texto blanco al pasar el mouse */
}
</style>